import { createFileRoute } from "@tanstack/react-router";

import { BuilderPage } from "~/components/builder/builder-page";
import {
  buildBuilderPageMeta,
  loadBuilderPageContent,
} from "~/lib/builder/page";
import { BRAND_URL } from "~/lib/shared/brand";
import { createBreadcrumbStructuredData } from "~/lib/shared/meta";

const URL_PATH = "/how-it-works";
const CANONICAL_URL = `${BRAND_URL}${URL_PATH}`;

const HowItWorksPage = () => <BuilderPage content={Route.useLoaderData()} />;

export const Route = createFileRoute("/_public/how-it-works")({
  staticData: { title: "How It Works" },
  staleTime: 6 * 60 * 60 * 1000, // 6 hours
  loaderDeps: ({ search }) => ({ search }),
  loader: ({ deps }) =>
    loadBuilderPageContent({ urlPath: URL_PATH, search: deps.search }),
  head: ({ loaderData }) => ({
    ...buildBuilderPageMeta({
      content: loaderData,
      canonicalUrl: CANONICAL_URL,
    }),
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify(
          createBreadcrumbStructuredData([
            { name: "Home", url: BRAND_URL },
            { name: "How It Works", url: CANONICAL_URL },
          ]),
        ),
      },
    ],
  }),
  component: HowItWorksPage,
});
